import { callExternalApi } from './external-api.service'
import API_PATHS from '../constants/API_PATHS'

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL

export const svc_getAuth0User = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_AUTH0_USER(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_sendVerificationEmail = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.SEND_VERIFICATION_EMAIL(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_createUser = async (accessToken, userObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_USER(userObj.userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getUser = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_USER(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateUser = async (accessToken, userId, userObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_USER(userId)}`,
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteUser = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_USER(userId)}`,
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

// USER PREFERENCES

export const svc_createUserPreference = async (accessToken, userId, userPreferenceObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_USER_PREFERENCE(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userPreferenceObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getUserPreference = async (accessToken, userId, preferenceKey) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_USER_PREFERENCE(userId, preferenceKey)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getUserPreferences = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_USER_PREFERENCES(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateUserPreference = async (accessToken, userId, preferenceKey, userPreferenceObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_USER_PREFERENCE(userId, preferenceKey)}`,
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userPreferenceObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteUserPreference = async (accessToken, userId, preferenceKey) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_USER_PREFERENCE(userId, preferenceKey)}`,
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_deleteUserPreferences = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.DELETE_USER_PREFERENCES(userId)}`,
        method: 'DELETE',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}


// USER EVENTS

export const svc_createUserEvent = async (accessToken, userId, userEventObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.CREATE_USER_EVENT(userId)}`,
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userEventObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_getUserEvents = async (accessToken, userId) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.GET_USER_EVENTS(userId)}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}

export const svc_updateUserEvent = async (accessToken, userId, eventId, userEventObj) => {
    const config = {
        url: `${apiServerUrl}${API_PATHS.UPDATE_USER_EVENT(userId, eventId)}`,
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        data: userEventObj,
    }

    const { data, error } = await callExternalApi({ config })

    return {
        data: data || null,
        error,
    }
}


